import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLineChart2"><Path d="M9.66602 20V4H8.16602V20H9.66602Z" fill="currentColor"/><Path d="M3.5 20V10H2V20H3.5Z" fill="currentColor"/><Path d="M15.832 13V20H14.332V13H15.832Z" fill="currentColor"/><Path d="M21.998 20V7H20.498V20H21.998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart2;
